import React from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"
import { GENERAL_STYLE_HEADING } from "constants/general-style"
import COLOR_PALETTE from "constants/color-palette"

const ServiceBasePrice = ({ service: { basePrice }, compact }) => (
  <div style={styles.basePrice(compact)}>
    <span style={styles.basePriceLabel(compact)}>BASE SCHEDULED MAINTENANCE:</span>{" "}
    <span style={styles.basePriceValue}>{`$${basePrice.toFixed(0)}`}</span>
  </div>
)

ServiceBasePrice.propTypes = {
  service: PropTypes.shape({
    basePrice: PropTypes.number
  }),
  compact: PropTypes.bool
}

const styles = {
  basePrice: compact => ({
    letterSpacing: GENERAL_STYLE_HEADING.LETTER_SPACING,
    color: COLOR_PALETTE.BLACK,
    textTransform: "uppercase",
    display: "flex",
    alignItems: "center",
    fontWeight: 600,
    ...(compact
      ? {
        width: "100%",
        justifyContent: "space-between"
      }
      : {
        justifyContent: "flex-end"
      })
  }),

  basePriceLabel: compact => ({
    display: "block",
    lineHeight: 1.4,
    textAlign: "left",
    margin: "0 1em 0 0",
    fontSize: compact ? "1em" : "0.9em"
  }),

  basePriceValue: {
    display: "block"
  }
}

export default Radium(ServiceBasePrice)



// WEBPACK FOOTER //
// ./src/containers/service-details-full/service-base-price.jsx